import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return {
      title: { text: props.title },
      data: props.chartData,
      series: props.series,
      axes: props.axes,
    }
  }, [data, props])
}
